import React from "react";

// With a videoId this is the walkthrough itself, embedded via youtube-nocookie
// (the privacy-enhanced host Zoho's own video pages use). Without one it stands
// in for a recording that doesn't exist yet — deliberately obvious rather than
// a fake player.
export function VideoPlaceholder({ caption, videoId }: { caption: string; videoId?: string }) {
  return (
    <div className="flex flex-col gap-2">
      {videoId ? (
        <iframe
          className="aspect-video w-full rounded-lg border"
          src={`https://www.youtube-nocookie.com/embed/${videoId}?rel=0`}
          title={caption}
          allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      ) : (
        <div className="flex aspect-video items-center justify-center rounded-lg border border-dashed bg-muted/30">
          <span className="text-xs text-muted-foreground">Walkthrough video coming soon</span>
        </div>
      )}
      <span className="text-xs text-muted-foreground">{caption}</span>
    </div>
  );
}
